import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useSSRGetSingleCollection(collectionId: string) {
  const { data: collection, isFetching, isError } = useQuery(
    ['collection-retrieve', collectionId],
    () => BackendService.instance.collection.getSingleCollection(collectionId),
    {
      staleTime: 1000 * 60 * 5,
    },
  );
  return {
    collection,
    isError,
    isFetching,
  };
}

export default useSSRGetSingleCollection;
